import { useState } from 'react';
import { useLoading } from 'react-simplikit';

import { Button } from '@/shared/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/shadcn/dialog';
import { Input } from '@/shared/components/shadcn/input';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onCreate: (title: string) => Promise<void>;
  initialTitle?: string;
  onUnmount: () => void;
};

export function CreateBoardDialog({
  isOpen,
  onCancel,
  onCreate,
  initialTitle = '',
  onUnmount,
}: Props) {
  const [loading, startLoading] = useLoading();
  const [value, setValue] = useState(initialTitle);

  const handleAnimationEnd = (event: React.AnimationEvent) => {
    if (!isOpen && event.animationName === 'exit') {
      onUnmount();
    }
  };

  const handleCreate = async () => {
    const trimmedValue = value.trim();
    if (!trimmedValue || loading) return;

    try {
      await startLoading(onCreate(trimmedValue));
    } catch {
      return;
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => onCancel()}>
      <DialogContent onAnimationEnd={handleAnimationEnd}>
        <DialogHeader>
          <DialogTitle>Create new board</DialogTitle>
        </DialogHeader>
        <Input
          value={value}
          placeholder="e.g. Spring Product UGC"
          onChange={(e) => setValue(e.target.value)}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleCreate} loading={loading} disabled={value.trim().length === 0}>
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
